import type { DanceSeoHead } from "../danceSeoTypes.js";

// it translation of the English source (shared/danceSeoHeads/en.ts); numbers must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Generatore di video di danza con IA a partire dalla musica",
    description:
      "Trasforma ogni canzone in un video di danza con l'IA. Solmi pianifica la coreografia di ogni sezione e renderizza danza e lip-sync. Gratis per iniziare.",
    h1: "Generatore di video di danza con IA: trasforma ogni canzone in un video di danza",
  },
  photo: {
    title: "Far ballare una foto con l'IA: foto che ballano | Solmi",
    description:
      "Fai ballare una foto con l'IA: usa una foto a figura intera, scegli un passo o una tua clip e aggiungi una canzone. Solmi lo mette a tempo. Gratis per iniziare.",
    h1: "Fai ballare una foto: generatore di balli con IA a partire da una foto",
  },
  inbound:
    "Vuoi che l'artista balli? Il [generatore di video di danza con IA](/ai-dance-video-generator) pianifica la coreografia di ogni sezione della tua canzone e renderizza un video di danza completo.",
};

export default head;
